import React, { useCallback, useEffect, useRef, useState } from "react";
import MediaQuery from "react-responsive";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Spreadsheet, MobileSpreadsheet } from "../Spreadsheet/Spreadsheet";
import { DIIA_RESET, signDocs as diiaSign } from "../../actions/diia";
import {
  DOCS_UPDATE,
  DOCS_RESET,
  fetchDocs,
  selectDocs,
} from "../../actions/docs";
import { SIGN_RESET, signDocs } from "../../actions/sign";
import styles from "../../styles/Docs/Docs.module.css";
import DocsToolbar from "./DocsToolbar";
import DocsToolbarDevice from "./DocsToolbarDevice";
import { AddAttributesDocPopup } from "../attributes/AddAttributesDocPopup";

import { SignPopup } from "../Popup/SignPopup";
import { DiiaSignPopup } from "../Popup/DiiaSignPopup";
import { FileSignPopup } from "../Popup/FileSignPopup";
import { docsFilter } from "../../actions/filter";
import { useParams } from "react-router-dom";

export default function Docs() {
  const params = useParams();
  const dispatch = useAppDispatch();
  const docs = useAppSelector((state) => state.docs);
  const filter = useAppSelector((state) => state.filter);
  const diia = useAppSelector((state) => state.diia);
  const sign = useAppSelector((state) => state.sign);
  const user = useAppSelector((state) => state.user);
  const [showPopup, setShowPopup] = useState(false);
  const [showFilePopup, setShowFilePopup] = useState(false);
  const [showDiiaPopup, setShowDiiaPopup] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState<string[]>([]);
  const [signMethods, setSignMethods] = useState<Record<string, any>>({});
  const [editAttrPopup, setEditAttrPopup] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [multiSelect, setMultiSelect] = useState<{ isSelected: boolean; range: number[] }>({
    isSelected: false,
    range: [],
  });
  const type = () => params.type;
  const isArchived = params.type === 'archived' ?  true : false ;
const selectedDocsRef = useRef(selectedDocs);

useEffect(() => {
  selectedDocsRef.current = selectedDocs;
}, [selectedDocs]);

const clickDiiaSignButton = useCallback(
  (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch({ type: SIGN_RESET });
    dispatch(diiaSign(selectedDocsRef.current));
    setShowDiiaPopup(true);
  },
  []
);

const clickSignButton = useCallback(
  (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch({ type: SIGN_RESET });
    setShowPopup(true);
  },
  []
);

const clickFileSignButton = useCallback(
  (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch({ type: SIGN_RESET });
    setShowFilePopup(true);
  },
  []
);

const submitForm = useCallback(
  (key: any) => {
    const selected = selectedDocsRef.current;
    const signed = docs.list?.reduce((memo: Record<string, boolean>, el: any) => {
      const signature = el.signatures?.find((sign: { stamp: boolean }) => !sign.stamp);
      const stamp = el.signatures?.find((sign: { stamp: boolean }) => sign.stamp);
      memo[el.id] = signature && (stamp || !user.company.stamp);
      return memo;
    }, {});
    dispatch(
      signDocs(
        selected.filter((id) => !signed[id]),
        key,
        false,
      ),
    );
  },
  [docs.list],
);

  const docsUpdate = () => {
    dispatch({ type: DOCS_RESET });
    dispatch(docsFilter(params.type ?? ""));
    setMultiSelect({ isSelected: false, range: [] });
  };

  const checkSignedDocs = docs.list?.reduce((memo: boolean, el: any) => memo || (
    selectedDocs.includes(el.id) && (
      el.signatures.length > 0 ||
      el.error?.code === 115
    )
  ), false);

  const setScroll = (e: React.UIEvent<HTMLElement>) => {
    setScrollPosition((e.target as HTMLElement)?.scrollTop);
  };

  const toggleCheckbox = useCallback(
    (id: string, isSelected: boolean, index: number, shiftKey: boolean) => {
      if (
        shiftKey &&
        (multiSelect.isSelected === isSelected ||
          (index >= Math.min(...multiSelect.range) &&
            index < Math.max(...multiSelect.range)))
      ) {
        setMultiSelect({
          isSelected: multiSelect.isSelected,
          range: [...multiSelect.range, index],
        });
      } else {
        setMultiSelect({ isSelected, range: [index] });
      }
      dispatch(selectDocs([id], isSelected));
    },
    [multiSelect],
  );

  const toggleAll = useCallback((isSelected: boolean) => {
    setMultiSelect({ isSelected: false, range: [] });
    dispatch(
      selectDocs(
        docs.list.filter((el: any) => !el.cancelled).map((el: any) => el.id),
        isSelected,
      ),
    );
  }, [docs.list, dispatch]);

  const closePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  const closeFilePopup = useCallback(() => {
    setShowFilePopup(false);
  }, []);

  const closeDiiaPopup = useCallback(() => {
    dispatch({ type: DIIA_RESET });
    setShowDiiaPopup(false);
  }, [dispatch]);



  // const clickSignButton = useCallback(
  //   (e) => {
  //     e.preventDefault();
  //       dispatch({ type: SIGN_RESET });
  //     setShowPopup(true);
  //   },
  //   [selectedDocs],
  // );

  // console.log(selectedDocs)

  // const clickDiiaSignButton = useCallback(
  //   (e) => {
  //     e.preventDefault();
  //       console.log('clickDiiaSignButton',selectedDocs)

  //       dispatch({ type: SIGN_RESET });
  //     dispatch(diiaSign(selectedDocs));
  //     setShowDiiaPopup(true);
  //   },
  //   [selectedDocs],
  // );

  // const clickFileSignButton = useCallback(
  //   (e) => {
  //     e.preventDefault();
  //       dispatch({ type: SIGN_RESET });
  //     setShowFilePopup(true);
  //   },
  //   [selectedDocs],
  // );

  // const submitForm = useCallback(
  //   (key) => {
  //     const signed = docs.list?.reduce((memo, el) => {
  //       const signature = el.signatures?.find((sign) => !sign.stamp);
  //       const stamp = el.signatures?.find((sign) => sign.stamp);
  //       memo[el.id] = signature && (stamp || !user.company.stamp);
  //       return memo;
  //     }, {});
  //     dispatch(
  //       signDocs(
  //         selectedDocs.filter((id) => !signed[id]),
  //         key,
  //         false,
  //       ),
  //     );
  //   },
  //   [docs.list, selectedDocs],
  // );

  useEffect(() => {
    const methods: Record<string, any> = {};
    const selected: string[] = [];
    let unsigned = false;

    docs.list?.forEach((el: any) => {
      if (docs.selected[el.id] /* && !el.cancelled */) {
        selected.push(el.id);
        if (!el.signed) {
          const docMethods = el.methods.reduce((memo: Record<string, any>, method: { alias: string }) => {
            memo[method.alias] = true;
            return memo;
          }, {});
          if (unsigned) {
            Object.keys(methods).forEach((key) => {
              if (!docMethods[key]) {
                delete methods[key];
              }
            });
          } else {
            Object.assign(methods, docMethods);
            unsigned = true;
          }
        } else {
          Object.keys(methods).forEach((key) => delete methods[key]); //очистка методів підпису, якщо вже є підписаний док
        }
      }
    });
    for (const method in methods) {
      switch (method) {
        case 'file':
          methods.file = clickFileSignButton;
          break;
        case 'diia':
          methods.diia = clickDiiaSignButton;
          break;
        case 'gryada':
          methods.gryada = clickSignButton;
          break;
        case 'stamp':
          methods.stamp = clickFileSignButton;
          break;
        default:
          methods[method] = null;
      }
    }
    setSelectedDocs(selected);
    setSignMethods(methods);
  }, [docs.selected]);

  useEffect(() => {
    const controller = new AbortController();
    if (!filter.page) {
      setScrollPosition(0);
      dispatch({ type: DOCS_RESET });
    }
    dispatch(fetchDocs(filter, controller.signal));
    return () => {
      if (!filter.page) {
        controller.abort();
      }
    };
  }, [filter]);

  useEffect(() => {
    if (sign.state === "success") {
      dispatch(selectDocs(selectedDocs, false));
      dispatch({ type: SIGN_RESET });
      dispatch({
        type: DOCS_UPDATE,
          payload: sign.list.reduce((memo: Record<string, any>, el: any) => {
            memo[el.id] = { ...el };
            return memo;
          }, {}),
      });
      closeFilePopup();
      closeDiiaPopup();
      closePopup();
    }
  }, [sign, selectedDocs]);
 
  useEffect(() => {
    if (multiSelect.range.length > 1) {
      const start = Math.min(multiSelect.range[0], multiSelect.range[1]);
      const end = Math.max(multiSelect.range[0], multiSelect.range[1]) + 1;
      const slice = docs.list
        ?.slice(start, end)
        .filter((el: any) => !el.cancelled)
        .map((doc: any) => doc.id);

      if (multiSelect.range.length > 2) {
        // if (multiSelect.range[0] < multiSelect.range[1]) {
        //   if (multiSelect.range[1] > multiSelect.range[2]) {
        //     const slice2 = docs.list?.slice(multiSelect.range[2], multiSelect.range[1] + 1).filter((el) => !el.cancelled).map((doc) => doc.id);
        //     dispatch(selectDocs(slice2, !multiSelect.isSelected));
        //   }
        // } else {
        //   if (multiSelect.range[1] < multiSelect.range[2]) {
        //     const slice3 = docs.list?.slice(multiSelect.range[1], multiSelect.range[2] + 1).filter((el) => !el.cancelled).map((doc) => doc.id);
        //     dispatch(selectDocs(slice3, !multiSelect.isSelected));
        //   }
        // }
        setMultiSelect({
          ...multiSelect,
          range: [multiSelect.range[0], multiSelect.range[2]],
        });
      } else {
        dispatch(selectDocs(slice, multiSelect.isSelected));
      }
    }
  }, [multiSelect]);

  return (
    <>
      <MediaQuery maxWidth={767}>
        <section className={`${styles.wrapper} ${styles.mobile} `}>
          {params.type !== "general" ?
          <DocsToolbar
              isArchived={isArchived}
              editAttribute={()=>setEditAttrPopup(true)}
              docsUpdate={docsUpdate}
              selectedDocs={selectedDocs}
              docs={docs}
              toggleAll={toggleAll}
            /> 
          : <div style={{height: "20px", backgroundColor: "white"}}></div>
          }
          <MobileSpreadsheet
            docsUpdate={docsUpdate}
            filter={filter}
            toggleCheckbox={toggleCheckbox}
            docs={docs}
            link={"/documents/{id}/view"}
            scrollPosition={scrollPosition}
            setScrollPosition={setScroll}
            sign={sign}
             selectedDocs={selectedDocs}
            heightTable={ selectedDocs.length > 0 && Object.keys(signMethods).length > 0 }
          />
          {selectedDocs.length > 0 && Object.keys(signMethods).length > 0 && (
            <DocsToolbarDevice
              selectedDocs={selectedDocs}
              signMethods={signMethods}
            />
          )}
        </section>
      </MediaQuery>

      <MediaQuery minWidth={768}>
        <section className={styles.wrapper}>
          {params.type !== "general" && (
              <DocsToolbar
                docsUpdate={docsUpdate}
                isArchived={isArchived}
                editAttribute={()=>setEditAttrPopup(true)}
                type={type}
                selectedDocs={selectedDocs}
                clickSignButton={
                  (signMethods.gryada && !checkSignedDocs)
                    ? clickSignButton
                    : null
                }
                clickDiiaSignButton={
                  (signMethods.diia && !checkSignedDocs)
                    ? clickDiiaSignButton
                    : null
                }
                clickFileSignButton={
                  (signMethods.file && !checkSignedDocs)
                    ? clickFileSignButton
                    : null
                }
                clickStampButton={
                  (signMethods.stamp && !checkSignedDocs)
                    ? clickFileSignButton
                    : null
                }
                signMethods={signMethods}
              />
          )}
          <Spreadsheet
            filter={filter}
            toggleAll={toggleAll}
            toggleCheckbox={toggleCheckbox}
            docs={docs}
            link={"/documents/{id}/view"}
            scrollPosition={scrollPosition}
            setScrollPosition={setScroll}
            sign={sign}
          />
        </section>
      </MediaQuery>

      {showPopup ? (
        <SignPopup
          clickCloseButton={closePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
      {showDiiaPopup ? (
        <DiiaSignPopup clickCloseButton={closeDiiaPopup} diia={diia} />
      ) : null}
      {showFilePopup ? (
        <FileSignPopup
          clickCloseButton={closeFilePopup}
          onSubmit={submitForm}
          sign={sign}
        />
      ) : null}
        {editAttrPopup ? (
          <AddAttributesDocPopup
            handleClose={() => setEditAttrPopup(false)}
            selectedDocs = {selectedDocs}
          />
        ) : null}
      
    </>
  );
}
